import { render, staticRenderFns } from "./aquatic_products.vue?vue&type=template&id=5554e154&scoped=true"
import script from "./aquatic_products.vue?vue&type=script&lang=js"
export * from "./aquatic_products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5554e154",
  null
  
)

export default component.exports